import React from "react";
import ModalWrapper from "./ModalWrapper";
import securePayment from "../images/secured-payment.svg";
import Loader from "./Loaders";

class ModalLoader extends React.Component {
  back = () => {
    this.props.nextModal("MEMBER_DETAILS");
  };

  render() {
    return (
      <ModalWrapper
        title="Great. How do we respond to you?"
        subtitle="Login or Enter contact details to proceed"
        {...this.props}
        okText="Next"
        onOk={this.handleNext}
        showOk={false}
        back={this.back}
        footerImage={securePayment}
        footerPara="100% Secured Payments - Book online through Trodly website or Mobile App and relax!"
        footerBanner={true}>
        <Loader color="#33cc99" size="2rem" contextLoader />
      </ModalWrapper>
    );
  }
}

export default ModalLoader;
